import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function LegalPage({ title, field, defaultText }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const text = settings?.[field] || defaultText;

  return (
    <div className="bg-cream min-h-screen">
      <Navbar />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="overline mb-4"><span className="gold-line" />Rechtliches</div>
          <h1 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight mb-10">{title}</h1>
          <div className="prose prose-neutral max-w-none whitespace-pre-line text-ink/80 leading-relaxed">
            {text}
          </div>
          {settings?.legal_name && (
            <div className="mt-12 pt-6 border-t border-[#E5E0D8] text-sm text-ink/70">
              Betreiber: <strong>{settings.legal_name}</strong>
              {settings.email && <div>E-Mail: {settings.email}</div>}
              {settings.phone && <div>Telefon: {settings.phone}</div>}
              {settings.store_address && <div>Adresse: {settings.store_address}</div>}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export const ImpressumPage = () => (
  <LegalPage
    title="Impressum"
    field="legal_text"
    defaultText={
      "Angaben gemäß § 5 TMG\n\n" +
      "[Firma / Inhaber bitte im Admin-Bereich ergänzen]\n" +
      "[Vollständige Anschrift]\n\n" +
      "Kontakt\n" +
      "Telefon: [Telefonnummer]\n" +
      "E-Mail: [E-Mail-Adresse]\n\n" +
      "Umsatzsteuer-ID: [USt-IdNr.]\n\n" +
      "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:\n" +
      "[Name, Anschrift]\n\n" +
      "Hinweis: Diese Vorlage ist ein Platzhalter. Bitte trage deine vollständigen Impressumsdaten im Admin-Bereich ein."
    }
  />
);

export const DatenschutzPage = () => (
  <LegalPage
    title="Datenschutz"
    field="privacy_text"
    defaultText={
      "Datenschutzerklärung\n\n" +
      "Der Schutz deiner persönlichen Daten ist uns ein wichtiges Anliegen. " +
      "Wir behandeln deine personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO) sowie dieser Datenschutzerklärung.\n\n" +
      "1. Verantwortliche Stelle\n" +
      "[Firma, Anschrift bitte im Admin-Bereich ergänzen]\n\n" +
      "2. Erhebung und Verarbeitung von Daten\n" +
      "Wenn du uns über das Anfrageformular oder WhatsApp kontaktierst, speichern wir die von dir übermittelten Daten (Name, Telefonnummer, ggf. Nachricht und Wunschdatum) zur Bearbeitung deiner Anfrage.\n\n" +
      "3. Speicherung & Löschung\n" +
      "Deine Daten werden ausschließlich zur Bearbeitung deiner Anfrage genutzt und nach Abschluss gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.\n\n" +
      "4. Deine Rechte\n" +
      "Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner personenbezogenen Daten. Wende dich hierfür an die oben genannte Kontaktadresse.\n\n" +
      "Hinweis: Diese Vorlage ist ein Platzhalter. Bitte ergänze deine individuelle Datenschutzerklärung im Admin-Bereich."
    }
  />
);
